export default __webpack_public_path__ + "static/media/nehnutelnost.a6a5216c.jpg";